import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const subtitle= "Faithful love Success Stories";
const title= "Read from clients that met their soul partners on our platform";

let StoryContentList = [
    {
        imgUrl: 'assets/images/story/00.png',
        imgAlt: 'Adenkule & Rachel',
        title: 'Adenkule & Rachel',
        desc: "Tegal changed my life! I met my soulmate on this platform, and we're now happily married. Thank you, Tegal is your go to match making app",
        btnText: "Read More",
    },
    {
        imgUrl: 'assets/images/story/01.jpg',
        imgAlt: 'Imran Hassan Ali',
        title: 'Imran Hassan Ali',
        desc: "I was skeptical at first, but Tegal's personalized approach helped me find someone truly special. We're excited to start our new life together!",
        btnText: "Read More",
    },
    {
        imgUrl: 'assets/images/story/02.png',
        imgAlt: 'Akinboye & Emily',
        title: 'Akinboye & Emily',
        desc: "Tegal's focus on meaningful connections really sets them apart. I've never felt more supported and understood in my search for love",
        btnText: "Read More",
    },
    {
        imgUrl: 'assets/images/story/03.jpg',
        imgAlt: 'Raheem',
        title: 'Raheem',
        desc: "I was losing hope in finding someone special, but Tegal's team worked tirelessly to match me with someone amazing. Thank you for believing in me!",
        btnText: "Read More",
    },
    {
        imgUrl: 'assets/images/story/04.png',
        imgAlt: 'David & Sophia',
        title: 'David Sophia',
        desc: "I've tried other dating apps, but Tegal's commitment to safety and security gave me the confidence to be myself. I'm so grateful to have found my partner here!",
        btnText: "Read More",
    },
    {
        imgUrl: 'assets/images/story/05.jpg',
        imgAlt: 'Dr. Ibrahim Saleh',
        title: 'Dr. Ibrahim Saleh',
        desc: "Tegal's community is amazing! The support and encouragement from the team and other members helped me stay positive and focused on finding love.",
        btnText: "Read More",
    },
]


class StorySection extends Component {
    state = {  } 
    render() { 
        return (
            <section className="story-section padding-tb bg-img">
                <div className=" container">
                    <div className="section-header">
                        <h4>{subtitle}</h4>
                        <h2>{title}</h2>
                    </div>
                    <div className="section-wrapper">
                        <div className="row justify-content-center g-4">
                            {StoryContentList.map((val, i) => (
                                <div className="col-lg-4 col-md-6 col-12" key={i}>
                                    <div className="story-item lab-item">
                                        <div className="lab-inner">
                                            <div className="lab-thumb">
                                                <img 
                                                    src={`${val.imgUrl}`} 
                                                    alt={`${val.imgAlt}`}
                                                />
                                            </div>
                                            <div className="lab-content">
                                                <h4><Link to="/blog-single">{val.title}</Link></h4>
                                                <p>{val.desc}</p>
                                                {/* <Link to="/blog-single" className="lab-btn"><i className="icofont-circled-right"></i>{val.btnText}</Link> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default StorySection;